import script from "./TileAllDashboardTasks.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileAllDashboardTasks.vue?vue&type=script&setup=true&lang=ts"

import "./TileAllDashboardTasks.vue?vue&type=style&index=0&id=5036c357&lang=css"

const __exports__ = script;

export default __exports__